import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const GeckoBoardShape = {
  api_key: Yup.string().label("API Key").min(32).max(32).required(),
  dataset_name: Yup.string().label("Dataset Name").max(64).required(),
};

export interface GeckoBoardInput {
  api_key: string;
  dataset_name: string;
}

yupResolver<GeckoBoardInput>(Yup.object().shape(GeckoBoardShape));
